export default {
      id: "link-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#link",
      toString: function () {
        return this.url;
      }
    }